export default {
  title: 'Layouts',
  description: 'Cadastre os modelos visuais usados para montar as páginas dos sites.',
  labels: {
    new: 'Novo Layout',
  },
  fields: {
    text: 'Nome do Layout',
    is_active: 'Ativo',
  }
};
